@if (show) {
  <div class="outer-popup-container">
    <div class="arrow-up">
    </div>
    <div class="popup-container">
      <rask-input [label]="texts.angeNamn" [(ngModel)]="model.namn" [required]="true" aid="inputSparaSokAngeNamn"></rask-input>
      <div class="row buttons">
        <rask-button color="primary" (click)="trySave()" aid="buttonSparaSokFilter">{{texts.spara}}</rask-button>
        <rask-button color="secondary" (click)="abort()" aid="buttonSparaSokFilterAvbryt">{{texts.avbryt}}</rask-button>
      </div>
      <div class="row">
        @if (errors) {
          <div class="feedback-panel">
            @for (error of errors; track error) {
              <small class="text-danger">{{error}}</small>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
